'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCast = function MdCast(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm1.6 16.6c10.1 0 18.4 8.2 18.4 18.4h-3.4c0-8.3-6.7-15-15-15v-3.4z m0 6.8c6.5 0 11.8 5.1 11.8 11.6h-3.4c0-4.6-3.7-8.4-8.4-8.4v-3.2z m0 6.6c2.8 0 5 2.3 5 5h-5v-5z m33.4-25c1.8 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.6 3.4-3.4 3.4h-11.6v-3.4h11.6v-23.2h-30v5h-3.4v-5c0-1.8 1.6-3.4 3.4-3.4h30z' })
        )
    );
};

exports.default = MdCast;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/cast.js
// module id = 1350
// module chunks = 168707334958949